import React from 'react';
import PropTypes from 'prop-types';
import './TableCellText.scss';

const ShowProfileCell = props => {
  let { text, ...otherProps } = props;

  return (
    <div className={'SimpleTextCellContainer p-0'}>
      <span className={'SimpleTextCellContainer--text'} {...otherProps} style={{ maxWidth: '400px' }}>
        {text}
      </span>
    </div>
  );
};

ShowProfileCell.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ShowProfileCell;
